import { IPage, ISearchPage, IPgProps, IPageRet } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'



//维修物资
export interface IArchivesAssetsDetail {
    amount?: number
    availableStock?: number
    barCode?: string
    code?: string
    createTime?: string
    department?: string
    deposit?: string
    inventoryNum?: number
    inventoryOccupied?: number
    materialCode?: string
    materialName?: string
    model?: string
    num?: number
    price?: number
    receiveCode?: string
    shelfCode?: string
    status?: string
    supplierName?: string
    typeCode?: string
    unitCode?: string
    user?: string
    warehouseName?: string
}
export interface IAssetsDetail {
    branch?: string
    branchList?: string
    brandCode?: string
    brandName?: string
    brandNameEn?: string
    code?: string
    enable?: string
    factoryCode?: string
    key?: string
    limitLower?: string
    limitUpper?: string
    madeFrom?: string
    minOrderNum?: string
    model?: string
    name?: string
    nameEn?: string
    note?: string
    purchasePrice?: number
    replaceCode?: string
    retailPrice?: string
    status?: string
    typeCode?: string
    typeName?: string
    typeNameEn?: string
    unitCode?: string
    unitName?: string
    unitNameEn?: string
    ver?: string
    wholesalePrice?: string
}

export interface IAssetsDetailSearchFields extends ISearchPage {
    code?: string
    name?: string
}

//详情
export interface IAssetsListDetail {
    // id: string
    amount?: number
    availableStock?: number
    barCode?: string
    code: string
    createTime?: string
    department?: string
    deposit?: string
    inventoryNum?: number
    inventoryOccupied?: number
    materialCode?: string
    materialName?: string
    model?: string
    num?: number
    price?: number
    receiveCode?: string
    shelfCode?: string
    status?: string
    supplierName?: string
    typeCode?: string
    unitCode?: string
    user?: string
    warehouseName?: string
    departmentStatus?: number | null
    [key: string]: any
}

//搜索条件
export interface IAssetsListSearchFields {
    code?: string
    name?: string
    vehicleBrandCode?: string
    vehicleModelCode?: string
    [key: string]: any
}

export interface IAssetsListSearch extends IAssetsListSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch extends IAssetsListSearchFields, ISearchPage { }

//新增
export interface IAssetsListInsert extends IAssetsListDetail { }

//编辑
export interface IAssetsListUpdate extends IAssetsListInsert {
    id: string
}
class AssetsListService {
    async page(searchVo: IAssetsListSearch,) {
        const apiUrl = '/assets/assets/stock/page'
        return await httpRequest.post<IPage<IAssetsListDetail>>(apiUrl, searchVo)
    }
    async flowRecordPage(searchVo: IAssetsListSearch,) {
        const apiUrl = '/assets/moveRecord/page'
        return await httpRequest.post<IPage<IAssetsListDetail>>(apiUrl, searchVo)
    }
    async userPage(searchVo: IAssetsListSearch,) {
        const apiUrl = '/assets/assets/receive/page'
        return await httpRequest.post<IPage<IAssetsListDetail>>(apiUrl, searchVo)
    }
    //导出
    async export(searchVo: IAssetsListSearch) {
        const appPageUrl = "/assets/assets/stock/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //导出
    async exportUser(searchVo: IAssetsListSearch) {
        const appPageUrl = "/assets/assets/receive/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    async transferLogPage(searchVo: IAssetsListSearch,) {
        const apiUrl = '/assets/transferRecord/page'
        return await httpRequest.post<IPage<IAssetsListDetail>>(apiUrl, searchVo)
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/assets/assets/transferShelf/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    async goodsTransfer(searchVo: any,) {
        const apiUrl = '/assets/assets/move/shift'
        return await httpRequest.post<IPage<IAssetsListDetail>>(apiUrl, searchVo)
    }
    // 更新资产部门使用状态
    async updateDepartmentStatus(id: string) {
        const apiUrl = `/assets/assets/isUse/${id}`
        return await httpRequest.get<any>(apiUrl)
    }
}

export const assetsListService = new AssetsListService()
